/* Maison Store — video players. One clip plays at a time, muted by default,
   paused offscreen and when the tab is hidden. Autoplay respects reduced motion and data saving. */
(function () {
  if (customElements.get('maison-video')) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var conn = navigator.connection || {};
  var canAutoplay = function () {
    return !reduced.matches && !conn.saveData;
  };
  var players = [];

  class MaisonVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      players.push(this);
      this.autoplay = this.hasAttribute('data-autoplay');
      this.autoPaused = false;
      this.userPaused = false;
      this.startBtn = this.querySelector('[data-mz-start]');
      this.playBtn = this.querySelector('[data-mz-play]');
      this.muteBtn = this.querySelector('[data-mz-mute]');

      var self = this;
      if (this.startBtn) this.startBtn.addEventListener('click', function () { self.userPaused = false; self.play(); });
      if (this.playBtn) this.playBtn.addEventListener('click', function () {
        if (self.video.paused) { self.userPaused = false; self.play(); } else { self.userPaused = true; self.video.pause(); }
      });
      if (this.muteBtn) this.muteBtn.addEventListener('click', function () { self.video.muted = !self.video.muted; });
      this.video.addEventListener('click', function () {
        if (self.video.paused) { self.userPaused = false; self.play(); } else { self.userPaused = true; self.video.pause(); }
      });

      this.video.addEventListener('play', function () {
        players.forEach(function (p) { if (p !== self && !p.video.paused) { p.autoPaused = false; p.video.pause(); } });
        self.sync();
      });
      this.video.addEventListener('playing', function () { self.classList.add('is-started'); self.sync(); });
      this.video.addEventListener('pause', function () { self.sync(); });
      this.video.addEventListener('volumechange', function () { self.sync(); });
      this.video.addEventListener('timeupdate', function () {
        if (!self.video.duration) return;
        self.dispatchEvent(new CustomEvent('mz:progress', { bubbles: true, detail: self.video.currentTime / self.video.duration }));
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              if (!self.video.paused) { self.autoPaused = true; self.video.pause(); }
            } else if (self.autoplay && canAutoplay() && !self.userPaused && self.video.paused && (self.autoPaused || !self.classList.contains('is-started'))) {
              self.autoPaused = false;
              self.play();
            }
          });
        }, { threshold: 0.25 });
        this.observer.observe(this);
      } else if (this.autoplay && canAutoplay()) {
        this.play();
      }
      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      var i = players.indexOf(this);
      if (i > -1) players.splice(i, 1);
    }

    play() {
      var self = this;
      var p = this.video.play();
      if (p && p.catch) p.catch(function () { self.sync(); });
    }

    load(src, poster, title) {
      this.video.pause();
      this.classList.remove('is-started');
      if (poster) this.video.poster = poster; else this.video.removeAttribute('poster');
      var backdrop = this.querySelector('.mz-video__backdrop');
      if (backdrop && poster) backdrop.style.backgroundImage = "url('" + poster + "')";
      this.video.src = src;
      if (title) {
        this.video.setAttribute('aria-label', title);
        if (this.startBtn) this.startBtn.setAttribute('aria-label', 'Play video: ' + title);
      }
      this.video.load();
      this.userPaused = false;
      this.play();
    }

    sync() {
      var paused = this.video.paused;
      this.classList.toggle('is-playing', !paused);
      this.classList.toggle('is-muted', this.video.muted);
      if (this.playBtn) this.playBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      if (this.muteBtn) {
        this.muteBtn.setAttribute('aria-label', this.video.muted ? 'Turn sound on' : 'Turn sound off');
        this.muteBtn.setAttribute('aria-pressed', String(!this.video.muted));
      }
    }
  }

  class MaisonHero extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.player = this.querySelector('maison-video');
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-mz-clip]'));
      this.buttons.forEach(function (button) {
        button.addEventListener('click', function () { self.select(button); });
      });
      this.addEventListener('mz:progress', function (event) {
        var current = self.querySelector('[data-mz-clip].is-selected');
        if (current) current.style.setProperty('--mz-progress', event.detail);
      });
    }

    select(button) {
      if (!this.player || !this.player.video) return;
      if (button.classList.contains('is-selected')) {
        this.player.userPaused = false;
        this.player.play();
        return;
      }
      this.buttons.forEach(function (b) {
        var on = b === button;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', String(on));
        b.style.setProperty('--mz-progress', 0);
      });
      this.player.load(button.dataset.src, button.dataset.poster, button.dataset.title);
      var label = this.querySelector('[data-mz-clip-label]');
      if (label) label.textContent = button.dataset.title;
    }
  }

  document.addEventListener('visibilitychange', function () {
    players.forEach(function (p) {
      if (document.hidden) {
        if (!p.video.paused) { p.autoPaused = true; p.video.pause(); }
      } else if (p.autoplay && p.autoPaused && !p.userPaused && canAutoplay()) {
        var r = p.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) { p.autoPaused = false; p.play(); }
      }
    });
  });

  var onReduce = function (e) {
    if (e.matches) players.forEach(function (p) { if (p.autoplay && !p.video.paused) p.video.pause(); });
  };
  if (reduced.addEventListener) reduced.addEventListener('change', onReduce);

  customElements.define('maison-video', MaisonVideo);
  customElements.define('maison-hero', MaisonHero);
})();
